<template>
    <v-container class="pa-5" fluid>
        <page-title>
            Zlecenia
        </page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Zlecenia NCF
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Raport zleceń NCF
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisJobsNCFJobs')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport produktów zleceń
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Report produktów zleceń filtrowanych po dacie utworzenia.
                                    </div>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuFromProductsReport"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="jobProductsReportData.createdAt__gte"
                                                        label="Od"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearJobProductsReportData('createdAt__gte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getForwardDateForProductReport('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getBackwardDateForProductReport('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="jobProductsReportData.createdAt__gte"
                                                    first-day-of-week="1"
                                                    @input="menuFromProductsReport = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuToProductsReport"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="jobProductsReportData.createdAt__lte"
                                                        label="Do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearJobProductsReportData('createdAt__lte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getForwardDateForProductReport('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getBackwardDateForProductReport('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="jobProductsReportData.createdAt__lte"
                                                    first-day-of-week="1"
                                                    @input="menuToProductsReport = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        :disabled="!(jobProductsReportData.createdAt__lte && jobProductsReportData.createdAt__gte)"
                                        @click="generateJobProductsReport"
                                    >
                                        Generuj raport
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport użytków w zleceniach
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Report użytków w zleceniach filtrowanych po dacie utworzenia.
                                    </div>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuFromPartsReport"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="jobPartsReportData.createdAt__gte"
                                                        label="Od"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearJobPartsReportData('createdAt__gte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getForwardDateForPartsReport('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                                    @click="getBackwardDateForPartsReport('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="jobPartsReportData.createdAt__gte"
                                                    first-day-of-week="1"
                                                    @input="menuFromPartsReport = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuToPartsReport"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="jobPartsReportData.createdAt__lte"
                                                        label="Do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearJobPartsReportData('createdAt__lte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getForwardDateForPartsReport('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                                    @click="getBackwardDateForPartsReport('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="jobPartsReportData.createdAt__lte"
                                                    first-day-of-week="1"
                                                    @input="menuToPartsReport = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        :disabled="!(jobPartsReportData.createdAt__lte && jobPartsReportData.createdAt__gte)"
                                        @click="generateJobPartsReport"
                                    >
                                        Generuj raport
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'Jobs',
    components: {
        PageTitle,
    },
    mixins: [
        dateFormatter
    ],
    data() {
        return {
            jobProductsReportData: {
                createdAt__lte: null,
                createdAt__gte: null,
                userEmail: null,
            },
            jobPartsReportData: {
                createdAt__lte: null,
                createdAt__gte: null,
                userEmail: null,
            },
            actionLoading: {
                generateReport: false
            },
            menuFromProductsReport: false,
            menuToProductsReport: false,
            menuFromPartsReport: false,
            menuToPartsReport: false,
        }
    },
    computed: {
        userEmail() {
            return localStorage.getItem('userEmail')
        }
    },
    methods: {
        getBackwardDateForProductReport(createdAt) {
            if (Date.parse(this.jobProductsReportData[createdAt])) {
                this.jobProductsReportData[createdAt] = this.getDayBackward(this.jobProductsReportData[createdAt])
            }
        },
        getForwardDateForProductReport(createdAt) {
            if (Date.parse(this.jobProductsReportData[createdAt])) {
                this.jobProductsReportData[createdAt] = this.getDayForward(this.jobProductsReportData[createdAt])
            }
        },
        generateJobProductsReport() {
            addSentryBreadcrumb('ui.action', 'Generowanie raportu produktów zleceń.')

            this.actionLoading.generateReport = true
            this.jobProductsReportData['userEmail'] = this.userEmail
            this.$store.dispatch('reportsAndAnalysis/jobs/generateJobProductsReport', this.jobProductsReportData)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.jobProductsReportData = {
                        createdAt__lte: null,
                        createdAt__gte: null,
                        userEmail: null 
                    }
                    this.actionLoading.generateReport = false
                })
        },
        generateJobPartsReport() {
            addSentryBreadcrumb('ui.action', 'Generowanie raportu użytków zleceń.')

            this.actionLoading.generateReport = true
            this.jobPartsReportData['userEmail'] = this.userEmail
            this.$store.dispatch('reportsAndAnalysis/jobs/generateJobPartsReport', this.jobPartsReportData)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.jobPartsReportData = {
                        createdAt__lte: null,
                        createdAt__gte: null,
                        userEmail: null 
                    }
                    this.actionLoading.generateReport = false
                })
        },
        clearJobProductsReportData(filterName) {
            this.jobProductsReportData[filterName] = null
        },
        getBackwardDateForPartsReport(createdAt) {
            if (Date.parse(this.jobPartsReportData[createdAt])) {
                this.jobPartsReportData[createdAt] = this.getDayBackward(this.jobPartsReportData[createdAt])
            }
        },
        getForwardDateForPartsReport(createdAt) {
            if (Date.parse(this.jobPartsReportData[createdAt])) {
                this.jobPartsReportData[createdAt] = this.getDayForward(this.jobPartsReportData[createdAt])
            }
        },
        clearJobPartsReportData(filterName) {
            this.jobPartsReportData[filterName] = null
        },
        openReport(report) {
            this.$router.push({name: report})
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>